<template>
  <section>
    <breadcrumbs :items="breadcrumbs" />
    <h1 v-b-tooltip.hover class="mb-1 essay-title text-truncate">
      {{ $t("common.compare") }}
    </h1>
    <eg-b-alert
      v-if="stat && percentageOfSimilarity > 0"
      class="mt-3 mb-4"
      :variant="variantByPersentage"
      show
    >
      Approximate similarity of text is {{ percentageOfSimilarity }}%
    </eg-b-alert>
    <CodeDiff
      v-if="essay1 && essay2"
      ref="codeDiff"
      class="code-diff"
      :old-string="essay1?.content"
      :new-string="essay2?.content"
      :filename="essay1?.name"
      :new-filename="essay2?.name"
      hide-stat
      :context="20"
      output-format="side-by-side"
      diff-style="word"
      @diff="onDiff"
    />
    <eg-b-overlay :show="!essay1 || !essay2" no-wrap> </eg-b-overlay>
  </section>
</template>

<script>
import { getEssay } from "@/api";
import Breadcrumbs from "@/components/global/breadcrumbs.vue";
import { CodeDiff } from "v-code-diff";
import { advancedCompareTexts } from "@/utils/textComparison";

export default {
  name: "EssayCompareView",
  components: {
    Breadcrumbs,
    CodeDiff,
  },

  data() {
    return {
      essay1: null,
      essay2: null,
      breadcrumbs: [
        {
          text: "Essays",
          to: "/essays",
        },
        {
          text: "Compare",
          active: true,
        },
      ],
      stat: null,
    };
  },

  computed: {
    variantByPersentage() {
      if (this.percentageOfSimilarity > 90) {
        return "danger";
      }

      if (this.percentageOfSimilarity > 20) {
        return "warning";
      }

      return "success";
    },

    percentageOfSimilarity() {
      if (!this.stat) {
        return 0;
      }

      if (!this.stat.isChanged) {
        return 100;
      }

      const { changePercentage } = advancedCompareTexts(
        this.essay1.content,
        this.essay2.content
      );

      return Math.round((100 - changePercentage) * 100) / 100;
    },
  },

  async created() {
    await this.getEssay();
  },

  methods: {
    async getEssay() {
      const { id1, id2 } = this.$route.params;
      try {
        const [essayData1, essayData2] = await Promise.all([
          getEssay(id1),
          getEssay(id2),
        ]);
        this.essay1 = essayData1.data.essay;
        this.essay2 = essayData2.data.essay;
      } catch (error) {
        console.error(error);
      }
    },

    onDiff({ stat }) {
      this.stat = stat;
    },
  },
};
</script>

<style lang="scss" scoped>
.code-diff {
  &::v-deep {
    .diff-commandbar {
      display: none;
    }

    .diff-table {
      td:nth-child(3),
      td:nth-child(1),
      col:nth-child(3),
      col:nth-child(1) {
        display: none;
      }
    }
  }
}
</style>
